import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Token tidak ditemukan");
      return;
    }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("success"))
      .catch(e => {
        setStatus("error");
        setMessage(e.response?.data?.detail || "Verifikasi gagal");
      });
  }, [params]);

  return (
    <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="verify-email-page">
      {status === "loading" && (
        <>
          <Loader2 className="w-16 h-16 mx-auto animate-spin text-primary" />
          <h1 className="font-heading text-2xl font-black mt-6">Memverifikasi...</h1>
        </>
      )}
      {status === "success" && (
        <>
          <CheckCircle2 className="w-20 h-20 mx-auto text-green-600" />
          <h1 className="font-heading text-3xl font-black mt-6" data-testid="verify-success">Email Terverifikasi! 🎉</h1>
          <p className="text-muted-foreground mt-2">Akun kamu siap dipakai. Login sekarang!</p>
          <Button onClick={() => navigate("/login")} className="rounded-full mt-6">Masuk</Button>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle className="w-20 h-20 mx-auto text-destructive" />
          <h1 className="font-heading text-2xl font-black mt-6">Verifikasi Gagal</h1>
          <p className="text-muted-foreground mt-2">{message}</p>
          <Link to="/login"><Button variant="outline" className="rounded-full mt-6">Kembali ke Login</Button></Link>
        </>
      )}
    </div>
  );
};

export default VerifyEmail;
